import Vue from 'vue';
import Snotify from 'vue-snotify';

Vue.use(Snotify);
